/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useIsOpen } from 'integration/hooks/useIsOpen';
import { SxProps, Theme } from '@mui/system';
import { combineSX } from '@/utils/combineSX';
import { useSingleSettings } from '@/data/Settings';
import { parseHTML } from '@/utils/parseHTML';
import { formatPrice } from '@/utils/formatPrice';

type Props = {
	showMoreAvailable?: boolean;
	withoutBox?: boolean;
	sx?: SxProps<Theme>;
};

export const ExtendedZoneAlert: FC<Props> = ({
	sx,
	showMoreAvailable = true,
	withoutBox = false,
}) => {
	const showMore = useIsOpen(true);

	const { settings } = useSingleSettings();

	const minAmtExtendedZoneEG = useMemo(() => {
		const value = settings?.userData?.['com.min.amount.extended.zone.eg'];
		return value ? Number(value) : 0;
	}, [settings?.userData]);

	if (withoutBox) {
		return (
			<Box
				id="extended-zone-shipping"
				sx={combineSX([
					{
						color: '#D97706',
						fontSize: { xs: '14px', md: '13px' },
						fontWeight: '400',
						display: 'flex',
						alignItems: 'center',
					},
					sx,
				])}
				onClick={showMore.toggle}
			>
				<InfoIcon
					sx={{ color: '#D97706', fontSize: 'inherit', verticalAlign: 'middle', mr: 0.5 }}
				/>
				{'Envío gratís no disponible para esta zona*'}
			</Box>
		);
	}

	return (
		<Box
			id="extended-zone-shipping"
			sx={combineSX([
				{
					backgroundColor: '#FFFBEB',
					border: '1px solid #FEF3C7',
					color: '#D97706',
					padding: '8px',

					fontSize: { xs: '13px', md: '11px' },
					fontWeight: '400',
					borderRadius: '4px',
					// cursor: showMoreAvailable ? 'pointer' : 'default',

					display: 'flex',
					flexDirection: 'row',

					alignItems: showMore.open || !showMoreAvailable ? 'flex-start' : 'center',
				},
				sx,
			])}
		>
			<InfoIcon
				sx={{
					color: '#D97706',
					fontSize: 'inherit',
					mr: 0.5,
					mt: showMore.open || !showMoreAvailable ? '3px' : 0,
				}}
			/>
			<Typography component="span">
				{parseHTML(
					`<strong>Envío gratís</strong> no disponible para esta zona. Obtén envío sin costo en compras de <strong>${formatPrice(
						'es-MX',
						'MXN',
						minAmtExtendedZoneEG
					).replace('.00', '')} o más</strong>.`
				)}
			</Typography>
		</Box>
	);
};
